import {Link} from "react-router";
import {srcUrl} from "@/api/ImageApi.ts";
import type Campaign from "@/campaigns/model/Campaign.ts";

export default function CampaignCard({campaign, to, badge}: {
    campaign: Campaign;
    to: string;
    badge?: string;
}) {
    return <Link to={to}
                 className="group overflow-hidden rounded-xl border border-border/80 bg-card/90 shadow-lg shadow-black/10 transition-all duration-200 hover:-translate-y-1 hover:border-primary/60 hover:shadow-xl hover:shadow-primary/10 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50">
        <div className="relative grid h-40 place-items-center overflow-hidden bg-surface">
            <img src={srcUrl(campaign.image)} alt="" className="h-full w-full object-cover"/>
            <div className="pointer-events-none absolute inset-0 bg-linear-to-t from-card/65 to-transparent"/>
        </div>
        <div className="p-4">
            <div className="flex items-center gap-2">
                <h2 className="min-w-0 grow font-semibold group-hover:text-primary">{campaign.title}</h2>
                {badge && <span className="shrink-0 rounded-full border border-border bg-muted/60 px-2 py-0.5 text-[11px] text-muted-foreground">{badge}</span>}
            </div>
            {campaign.description && <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{campaign.description}</p>}
        </div>
    </Link>;
}
